import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { BottomSheet } from '@netexknowledge/smart-components';
import CustomIcon from '../../common/CustomIcon';
import { getLegend } from './gradebookMobileUtils';

// Swipe actions of the student sheet rows. `side` is where the action shows: the finger moves the other way.
const GESTURES = [
  {
    title: 'gradebook.scope.activities',
    items: [
      {
        side: 'left',
        icon: 'evaluable',
        swipe: 'gradebook.mobile.swipeRight',
        help: 'gradebook.mobile.activitySettings'
      },
      { side: 'right', icon: 'share-arrow', swipe: 'gradebook.mobile.swipeLeft', help: 'gradebook.mobile.openContent' }
    ]
  },
  {
    title: 'gradebook.mobile.unitsAndLessons',
    items: [
      {
        side: 'left',
        icon: 'up-arrow-sign',
        swipe: 'gradebook.mobile.swipeRight',
        help: 'gradebook.mobile.levelUpHelp'
      },
      {
        side: 'right',
        icon: 'right-direction',
        swipe: 'gradebook.mobile.swipeLeft',
        help: 'gradebook.mobile.levelDownHelp'
      }
    ]
  }
];

/**
 * Mobile (i) button: the icon legend (desktop explains each column on hover) and, for content,
 * the swipe gestures of the student sheet rows.
 */
const GradebookHelpButton = ({ isTasks }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="gradebook-help-button"
        aria-label={I18n.t('gradebook.mobile.help')}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <CustomIcon size={18} name="information-square" />
      </button>
      <BottomSheet
        open={open}
        onClose={() => setOpen(false)}
        closeLabel={I18n.t('common.close')}
        title={I18n.t('gradebook.mobile.legend')}
      >
        <ul className="gradebook-sheet-list">
          {getLegend(isTasks).map(({ icon, color, label }) => (
            <li key={icon} className="gradebook-sheet-row">
              <span className="gradebook-sheet-state">
                <CustomIcon name={icon} classes={`grade ${color}`} size={24} />
              </span>
              <span className="gradebook-sheet-text">
                <span className="gradebook-sheet-name">{label}</span>
              </span>
            </li>
          ))}
        </ul>
        {!isTasks && (
          <div className="gradebook-help-gestures">
            {GESTURES.map(group => (
              <section key={group.title}>
                <h3 className="gradebook-help-gestures-title">{I18n.t(group.title)}</h3>
                {group.items.map(gesture => (
                  <div key={gesture.help} className="gradebook-help-gesture">
                    <span className={`gradebook-help-gesture-thumb ${gesture.side}`} aria-hidden="true">
                      <i className={`custom-icons-${gesture.icon}`} />
                      <span className="gradebook-help-gesture-row" />
                    </span>
                    <span className="gradebook-help-gesture-text">
                      <span className="gradebook-help-gesture-swipe">{I18n.t(gesture.swipe)}</span>
                      <span className="gradebook-help-gesture-help">{I18n.t(gesture.help)}</span>
                    </span>
                  </div>
                ))}
              </section>
            ))}
          </div>
        )}
      </BottomSheet>
    </>
  );
};

GradebookHelpButton.propTypes = {
  isTasks: PropTypes.bool
};

export default GradebookHelpButton;
